import focusWhyMindfulnessText from './focus-why-mindfulness-text.md';
import focusWhyMindfulnessTextFr from './focus-why-mindfulness-text-fr.md';
import focusWhyMindfulnessTextEs from './focus-why-mindfulness-text-es.md';
import focusWhyMindfulnessTextAr from './focus-why-mindfulness-text-ar.md';
import focusWhyMindfulnessTextDe from './focus-why-mindfulness-text-de.md';
import focusWhyMindfulnessTextHi from './focus-why-mindfulness-text-hi.md';
import focusWhyMindfulnessTextId from './focus-why-mindfulness-text-id.md';
import focusWhyMindfulnessTextIt from './focus-why-mindfulness-text-it.md';
import focusWhyMindfulnessTextJa from './focus-why-mindfulness-text-ja.md';
import focusWhyMindfulnessTextKo from './focus-why-mindfulness-text-ko.md';
import focusWhyMindfulnessTextZh from './focus-why-mindfulness-text-zh.md';
import focusWhyMindfulnessTextRu from './focus-why-mindfulness-text-ru.md';
import focusWhyMindfulnessTextTh from './focus-why-mindfulness-text-th.md';
import focusWhyMindfulnessTextTr from './focus-why-mindfulness-text-tr.md';
import focusTheABCDMethodTechnique from './focus-the-abcd-method-technique.md';
import focusTheABCDMethodTechniqueFr from './focus-the-abcd-method-technique-fr.md';
import focusTheABCDMethodTechniqueEs from './focus-the-abcd-method-technique-es.md';
import focusTheABCDMethodTechniqueAr from './focus-the-abcd-method-technique-ar.md';
import focusTheABCDMethodTechniqueDe from './focus-the-abcd-method-technique-de.md';
import focusTheABCDMethodTechniqueHi from './focus-the-abcd-method-technique-hi.md';
import focusTheABCDMethodTechniqueId from './focus-the-abcd-method-technique-id.md';
import focusTheABCDMethodTechniqueIt from './focus-the-abcd-method-technique-it.md';
import focusTheABCDMethodTechniqueJa from './focus-the-abcd-method-technique-ja.md';
import focusTheABCDMethodTechniqueKo from './focus-the-abcd-method-technique-ko.md';
import focusTheABCDMethodTechniqueZh from './focus-the-abcd-method-technique-zh.md';
import focusTheABCDMethodTechniqueRu from './focus-the-abcd-method-technique-ru.md';
import focusTheABCDMethodTechniqueTh from './focus-the-abcd-method-technique-th.md';
import focusTheABCDMethodTechniqueTr from './focus-the-abcd-method-technique-tr.md';
import rechargeWhyResilienceText from './recharge-why-resilience-text.md';
import rechargeWhyResilienceTextFr from './recharge-why-resilience-text-fr.md';
import rechargeWhyResilienceTextEs from './recharge-why-resilience-text-es.md';
import rechargeWhyResilienceTextAr from './recharge-why-resilience-text-ar.md';
import rechargeWhyResilienceTextDe from './recharge-why-resilience-text-de.md';
import rechargeWhyResilienceTextHi from './recharge-why-resilience-text-hi.md';
import rechargeWhyResilienceTextId from './recharge-why-resilience-text-id.md';
import rechargeWhyResilienceTextIt from './recharge-why-resilience-text-it.md';
import rechargeWhyResilienceTextJa from './recharge-why-resilience-text-ja.md';
import rechargeWhyResilienceTextKo from './recharge-why-resilience-text-ko.md';
import rechargeWhyResilienceTextZh from './recharge-why-resilience-text-zh.md';
import rechargeWhyResilienceTextRu from './recharge-why-resilience-text-ru.md';
import rechargeWhyResilienceTextTh from './recharge-why-resilience-text-th.md';
import rechargeWhyResilienceTextTr from './recharge-why-resilience-text-tr.md';
import rechargeTheABCDMethodTechnique from './recharge-the-abcd-method-technique.md';
import rechargeTheABCDMethodTechniqueFr from './recharge-the-abcd-method-technique-fr.md';
import rechargeTheABCDMethodTechniqueEs from './recharge-the-abcd-method-technique-es.md';
import rechargeTheABCDMethodTechniqueAr from './recharge-the-abcd-method-technique-ar.md';
import rechargeTheABCDMethodTechniqueDe from './recharge-the-abcd-method-technique-de.md';
import rechargeTheABCDMethodTechniqueHi from './recharge-the-abcd-method-technique-hi.md';
import rechargeTheABCDMethodTechniqueId from './recharge-the-abcd-method-technique-id.md';
import rechargeTheABCDMethodTechniqueIt from './recharge-the-abcd-method-technique-it.md';
import rechargeTheABCDMethodTechniqueJa from './recharge-the-abcd-method-technique-ja.md';
import rechargeTheABCDMethodTechniqueKo from './recharge-the-abcd-method-technique-ko.md';
import rechargeTheABCDMethodTechniqueZh from './recharge-the-abcd-method-technique-zh.md';
import rechargeTheABCDMethodTechniqueRu from './recharge-the-abcd-method-technique-ru.md';
import rechargeTheABCDMethodTechniqueTh from './recharge-the-abcd-method-technique-th.md';
import rechargeTheABCDMethodTechniqueTr from './recharge-the-abcd-method-technique-tr.md';

const fileToPathMap = {
  'focus-why-mindfulness-text.md': focusWhyMindfulnessText,
  'focus-why-mindfulness-text-fr.md': focusWhyMindfulnessTextFr,
  'focus-why-mindfulness-text-es.md': focusWhyMindfulnessTextEs,
  'focus-why-mindfulness-text-ar.md': focusWhyMindfulnessTextAr,
  'focus-why-mindfulness-text-de.md': focusWhyMindfulnessTextDe,
  'focus-why-mindfulness-text-hi.md': focusWhyMindfulnessTextHi,
  'focus-why-mindfulness-text-id.md': focusWhyMindfulnessTextId,
  'focus-why-mindfulness-text-it.md': focusWhyMindfulnessTextIt,
  'focus-why-mindfulness-text-ja.md': focusWhyMindfulnessTextJa,
  'focus-why-mindfulness-text-ko.md': focusWhyMindfulnessTextKo,
  'focus-why-mindfulness-text-zh.md': focusWhyMindfulnessTextZh,
  'focus-why-mindfulness-text-ru.md': focusWhyMindfulnessTextRu,
  'focus-why-mindfulness-text-th.md': focusWhyMindfulnessTextTh,
  'focus-why-mindfulness-text-tr.md': focusWhyMindfulnessTextTr,
  'focus-the-abcd-method-technique.md': focusTheABCDMethodTechnique,
  'focus-the-abcd-method-technique-fr.md': focusTheABCDMethodTechniqueFr,
  'focus-the-abcd-method-technique-es.md': focusTheABCDMethodTechniqueEs,
  'focus-the-abcd-method-technique-ar.md': focusTheABCDMethodTechniqueAr,
  'focus-the-abcd-method-technique-de.md': focusTheABCDMethodTechniqueDe,
  'focus-the-abcd-method-technique-hi.md': focusTheABCDMethodTechniqueHi,
  'focus-the-abcd-method-technique-id.md': focusTheABCDMethodTechniqueId,
  'focus-the-abcd-method-technique-it.md': focusTheABCDMethodTechniqueIt,
  'focus-the-abcd-method-technique-ja.md': focusTheABCDMethodTechniqueJa,
  'focus-the-abcd-method-technique-ko.md': focusTheABCDMethodTechniqueKo,
  'focus-the-abcd-method-technique-zh.md': focusTheABCDMethodTechniqueZh,
  'focus-the-abcd-method-technique-ru.md': focusTheABCDMethodTechniqueRu,
  'focus-the-abcd-method-technique-th.md': focusTheABCDMethodTechniqueTh,
  'focus-the-abcd-method-technique-tr.md': focusTheABCDMethodTechniqueTr,
  'recharge-why-resilience-text.md': rechargeWhyResilienceText,
  'recharge-why-resilience-text-fr.md': rechargeWhyResilienceTextFr,
  'recharge-why-resilience-text-es.md': rechargeWhyResilienceTextEs,
  'recharge-why-resilience-text-ar.md': rechargeWhyResilienceTextAr,
  'recharge-why-resilience-text-de.md': rechargeWhyResilienceTextDe,
  'recharge-why-resilience-text-hi.md': rechargeWhyResilienceTextHi,
  'recharge-why-resilience-text-id.md': rechargeWhyResilienceTextId,
  'recharge-why-resilience-text-it.md': rechargeWhyResilienceTextIt,
  'recharge-why-resilience-text-ja.md': rechargeWhyResilienceTextJa,
  'recharge-why-resilience-text-ko.md': rechargeWhyResilienceTextKo,
  'recharge-why-resilience-text-zh.md': rechargeWhyResilienceTextZh,
  'recharge-why-resilience-text-ru.md': rechargeWhyResilienceTextRu,
  'recharge-why-resilience-text-th.md': rechargeWhyResilienceTextTh,
  'recharge-why-resilience-text-tr.md': rechargeWhyResilienceTextTr,
  'recharge-the-abcd-method-technique.md': rechargeTheABCDMethodTechnique,
  'recharge-the-abcd-method-technique-fr.md': rechargeTheABCDMethodTechniqueFr,
  'recharge-the-abcd-method-technique-es.md': rechargeTheABCDMethodTechniqueEs,
  'recharge-the-abcd-method-technique-ar.md': rechargeTheABCDMethodTechniqueAr,
  'recharge-the-abcd-method-technique-de.md': rechargeTheABCDMethodTechniqueDe,
  'recharge-the-abcd-method-technique-hi.md': rechargeTheABCDMethodTechniqueHi,
  'recharge-the-abcd-method-technique-id.md': rechargeTheABCDMethodTechniqueId,
  'recharge-the-abcd-method-technique-it.md': rechargeTheABCDMethodTechniqueIt,
  'recharge-the-abcd-method-technique-ja.md': rechargeTheABCDMethodTechniqueJa,
  'recharge-the-abcd-method-technique-ko.md': rechargeTheABCDMethodTechniqueKo,
  'recharge-the-abcd-method-technique-zh.md': rechargeTheABCDMethodTechniqueZh,
  'recharge-the-abcd-method-technique-ru.md': rechargeTheABCDMethodTechniqueRu,
  'recharge-the-abcd-method-technique-th.md': rechargeTheABCDMethodTechniqueTh,
  'recharge-the-abcd-method-technique-tr.md': rechargeTheABCDMethodTechniqueTr
};



export default fileToPathMap;



// WEBPACK FOOTER //
// ./src/data/playbooks/content-files.js